import React, { useState } from "react";
import Collapse from "rc-collapse";
import "rc-collapse/assets/index.css";
import DataFetcher from "../DataFetcher/DataFetcher";
import { FaArrowUpRightDots } from "react-icons/fa6";
import { FaPlus, FaWindowClose } from "react-icons/fa";

const MktRptAccordion = ({ type, classAppend, items }) => {
  const [activeKey, setActiveKey] = useState("0");
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=mktrptaccordion`;

  return (
    <DataFetcher url={API_URL}>
      {(data) => {
        const collapseItems = (items ? data.slice(0, items) : data).map((panel, i) => {
          const key = `${i}`;
          const isActive = activeKey === key;

          return {
            key,
            header: (
              <span className="accordion-header-content">
                {isActive ? (
                  <FaWindowClose style={{ marginRight: "8px" }} />
                ) : (
                  <FaPlus style={{ marginRight: "8px" }} />
                )}
                LUXURY MARKET REPORT FOR THE WEEK OF {panel.ReportName}
              </span>
            ),
            children: (
              <>
                <p>{panel.para1}</p>
                <a href="/market-report">
                  VIEW FULL REPORT <FaArrowUpRightDots />
                </a>
              </>
            ),
          };
        });

        return (
          <div className="mkt-report-accordion">
            <Collapse
              accordion
              activeKey={activeKey}
              onChange={(key) => setActiveKey(key)}
              className={`padding-top-30 panel-group accordion-${type || "color"} ${classAppend || ""}`}
            >
              {collapseItems.map((item) => (
                <Collapse.Panel
                  key={item.key}
                  header={item.header}
                  className="mkt-report-accordion"
                >
                  {item.children}
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
        );
      }}
    </DataFetcher>
  );
};

export default MktRptAccordion;
``
